<template>
    <p class="u-size-14 u-italic hint">
        <i :class="`el-icon-${icon} mr-4`" aria-hidden="true" />
        <slot />
    </p>
</template>

<script>
export default {
    props: {
        icon: { type: String, default: 'info' },
    },
}
</script>

<style lang="scss" scoped>
.hint {
    color: rgba($white, 0.7);
}
</style>
